import React, { FC } from 'react';
import './progress-bar.scss';

interface IProps {
  percents: number;
  additionalClassName?: string;
  shouldHidePercents?: boolean;
  colorFill?: string;
}

const ProgressBar: FC<IProps> = ({ percents, additionalClassName, colorFill, shouldHidePercents }) => {
  const progressWidth = `${percents}%`;

  return (
    <div className={`progress-bar ${additionalClassName || ''}`}>
      <div className='progress-bar-container'>
        <div className='progress-bar-filler' style={{ width: progressWidth, backgroundColor: colorFill }}/>
      </div>
      {!shouldHidePercents && <div className='progress-bar-percents'>{percents}%</div>}
    </div>
  );
};

export default ProgressBar;